import {
  CREATE_STATUS_SUCCESS,
  FETCH_STATUS_SUCCESS,
  GET_STATUS_SUCCESS,
  SAVE_STATUS_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_STATUS_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_STATUS_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_STATUS_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_STATUS_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
